import { usePageContext } from '@portal/processes/Page/PageContext';
import { useAtomValue } from 'jotai';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { LocaleEnum } from 'schema/locale';
import { offerSectionAtom } from '../../state/atoms/offerSectionAtom';
import { useLocale } from './useLocale';

type Options = {
  withScroll?: boolean;
  withRedirect?: boolean;
};

export function useGoToOffers({ withScroll = true, withRedirect = true }: Options = {}) {
  const locale = useLocale();
  const { getOfferCTALink } = usePageContext();
  const offerSectionAtomValue = useAtomValue(offerSectionAtom);
  const router = useRouter();

  const goToOffer = useCallback(() => {
    const offerBuilderCTA = getOfferCTALink();
    const scrollToOfferSection = withScroll && !!offerSectionAtomValue;

    if (scrollToOfferSection) {
      offerSectionAtomValue.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    } else if (withRedirect) {
      let newPath = offerBuilderCTA;
      if (locale === LocaleEnum.enUS) {
        newPath ||= '/get-your-ag1';
      } else {
        newPath ||= `/${locale}#offers`;
      }
      router.push(newPath);
    }
  }, [withScroll, offerSectionAtomValue, withRedirect, router, locale, getOfferCTALink]);

  return { goToOffer };
}
